import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import { generateUrls } from '@hooks/useBrand'

const generateTabBarItems = (notification) => {
  const urls = generateUrls(notification)
  const { editNotificationUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editNotificationUrl,
      key: 'details',
      title: notification?.title || 'Notification Details',
    },
  ]
}

export default generateTabBarItems
